import { AssetDTO } from 'api-models'
import { FaLock } from 'react-icons/fa'

interface HeaderSectionProps {
	asset: AssetDTO
	isOnboarding?: boolean
}

export const HeaderSection = ({
	asset,
	isOnboarding = true
}: HeaderSectionProps) => {
	return (
		<>
			{/* Header - Always visible */}
			<div className="flex flex-col gap-4 mb-4">
				<h1 className="md:text-[30px] text-[24px] md:leading-[36px] leading-[28px] font-medium text-t-default">
					{isOnboarding
						? 'Connect your Ad Account'
						: 'Connect a new ad account'}
				</h1>
				{isOnboarding ? (
					<p className="text-[16px] leading-[22px] text-t-checkbox-unactive">
						Authorize ClickGuard to connect to the primary ad platform
						<br />
						<span className="font-medium text-t-email-blue">
							{asset.name}
						</span>{' '}
						uses for advertising.
						<br />
						You can add additional platforms and ad accounts later!
					</p>
				) : (
					<p className="text-[16px] leading-[22px] text-t-checkbox-unactive">
						You are adding a new ad account connection to protect{' '}
						<span className="font-medium text-t-email-blue">{asset.name}</span>'s
						advertising budget.
					</p>
				)}
			</div>

			{/* Security Message - Always visible */}
			{isOnboarding && (
				<div className="flex items-start gap-2 text-brand mb-4">
					<FaLock className="w-4 h-4 flex-shrink-0 mt-[2px]" />
					<p className="text-[14px] leading-[18px]">
						ClickGuard won't modify ad budgets or interfere with campaigns.
					</p>
				</div>
			)}
		</>
	)
}
